import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./Header.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faBars,
  faXmark,
  faDownload,
} from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

import Offcanvas from "react-bootstrap/Offcanvas";
import InquiryFormModal from "../common_components/InquiryFormModal/InquiryFormModal";
import { Nav } from "react-bootstrap";

const Header = () => {
  const [show, setShow] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const [expanded, setExpanded] = useState(false);
  const [modalshow, setmodalshow] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const handleNavClick = (path) => {
    navigate(path);
    setExpanded(false);
  };

  const openModal = () => {
    setmodalshow(true);
    setExpanded(false); // close navbar
  };

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    // SCROLL HANDLER
    const section = params.get("section");
    if (section) {
      const el = document.getElementById(section);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
    }
    // MODAL HANDLER
    const modal = params.get("modal");
    if (modal === "contact-us") {
      setmodalshow(true);
    }
  }, [location]);

  return (
    <>
      <header className="header">
        <div class="inquirybtndiv">
          <a href="tel:+919607755557" class="inquirybtn">
            <span>
              <FontAwesomeIcon icon={faPhone} style={{ color: "#000" }} />
            </span>{" "}
            CALL US
          </a>
          <button
            class="inquirybtn"
            onClick={() => {
              setShowModal(true);
            }}
          >
            <span>
              <FontAwesomeIcon icon={faDownload} style={{ color: "#000" }} />
            </span>{" "}
            DOWNLOAD BROCHURE
          </button>
        </div>
        <div className="header_container">
          <div className="logo">
            <Link to="/">
              <img src="/assets/images/logo_swiper/atlas-logo.png" alt="Logo" />
            </Link>
          </div>

          <div className="header_right">
            {/* <nav className="nav_links">
              <Link to="/online-mba#home">Home</Link>
              <Link to="/online-mba#programs">Program</Link>
              <Link to="/online-mba#admissions">Admission</Link>
              <Link to="/online-mba#eligibility">Eligibility</Link>
              <Link to="/online-mba#fees">Fees</Link>
              <Link to="/online-mba#contact">Contact Us</Link>
            </nav> */}

            <Nav className="nav_links">
              <Nav.Link
                onClick={() => handleNavClick("/")}
                className={location.pathname === "/" ? "active" : ""}
              >
                Home
              </Nav.Link>

              <Nav.Link
                onClick={() => {
                  navigate("/learningwithoutlimits");
                  setExpanded(false);
                }}
              >
                Programs
              </Nav.Link>

              <Nav.Link
                onClick={() => {
                  navigate("/admissionprocess");
                  setExpanded(false);
                }}
              >
                Admissions
              </Nav.Link>

              <Nav.Link
                onClick={() => {
                  navigate("/eligibility");
                  setShow(false);
                }}
              >
                Fees
              </Nav.Link>

              <Nav.Link
                onClick={() => {
                  navigate("/eligibility");
                  setExpanded(false);
                }}
              >
                Eligibility
              </Nav.Link>

              {/* <Nav.Link
                    onClick={() => {
                      window.history.pushState(null, "", "/#contact-us");
                      openModal();
                      setExpanded(false);
                    }}
                  >
                    Contact Us
                  </Nav.Link> */}
            </Nav>

            <a href="tel:18002674040" className="phone">
              <FontAwesomeIcon icon={faPhone} />
              <span>9607755557</span>
            </a>

            <a
              href="https://wa.me/9607755557"
              className="whatsapp"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faWhatsapp} />
            </a>

            <button className="mobile_menu_btn" onClick={() => setShow(true)}>
              <FontAwesomeIcon icon={faBars} />
            </button>
          </div>
        </div>
      </header>

      <Offcanvas show={show} onHide={() => setShow(false)} placement="end">
        <Offcanvas.Header>
          <Offcanvas.Title>Menu</Offcanvas.Title>

          <button className="close_btn" onClick={() => setShow(false)}>
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </Offcanvas.Header>

        <Offcanvas.Body>
          {/* <div className="mobile_nav">
            <Link to="/" onClick={() => setShow(false)}>
              Home
            </Link>

            <Link to="/#about" onClick={() => setShow(false)}>
              About Us
            </Link>

            <Link to="/#program" onClick={() => setShow(false)}>
              Courses
            </Link>

            <Link to="/#blog" onClick={() => setShow(false)}>
              Blog
            </Link>

            <Link to="/contact" onClick={() => setShow(false)}>
              Contact Us
            </Link>

            <button
              className="contact_btn"
              onClick={() => {
                setShow(false);
                setShowModal(true);
              }}
            >
              Contact Us
            </button>
          </div> */}

          <Nav className="mobile_nav">
            <Nav.Link
              onClick={() => {
                setShow(false);
                handleNavClick("/");
              }}
              className={location.pathname === "/" ? "active" : ""}
            >
              Home
            </Nav.Link>

            <Nav.Link
              onClick={() => {
                navigate("/learningwithoutlimits");
                setShow(false);
              }}
            >
              Programs
            </Nav.Link>

            <Nav.Link
              onClick={() => {
                navigate("/admissionprocess");
                setShow(false);
              }}
            >
              Admissions
            </Nav.Link>

            <Nav.Link
              onClick={() => {
                navigate("/eligibility");
                setShow(false);
              }}
            >
              Fees
            </Nav.Link>

            <Nav.Link
              onClick={() => {
                navigate("/eligibility");
                setShow(false);
              }}
            >
              Eligibility
            </Nav.Link>

            {/* <Nav.Link
                    onClick={() => {
                      window.history.pushState(null, "", "/#contact-us");
                      openModal();
                      setExpanded(false);
                    }}
                  >
                    Contact Us
                  </Nav.Link> */}
          </Nav>
        </Offcanvas.Body>
      </Offcanvas>

      <InquiryFormModal show={showModal} onHide={() => setShowModal(false)} />
    </>
  );
};

export default Header;
